<script lang="ts" setup>
import { formatMessageTime } from '../../utils';

interface Props {
  time: number;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="mb-3 text-center text-sm leading-[22px] text-colorTextTertiary">
    {{ formatMessageTime(props.time, true) }}
  </div>
</template>
<style scoped></style>
